module.exports = __webpack_public_path__ + "static/img/huaweiPadM5.e30f9bea.png";